import { useEffect, useState } from 'react';

import { ChatButton } from './CustomerCenter';

let intervalCount = 0;

export default function ChannelTalkPreviewButton() {
  const [isLoad, setIsLoad] = useState(false);
  const [isShow, setIsShow] = useState(false);

  // 해당부분 리모트 파일 로드 시점 확인을 위해서 불가피하게 interval로 구현 추후 개선 필요
  const setShow = async (intervalId: number) => {
    intervalCount = +1;
    const type = await window.csHelper?.getType();
    if (type && type.enablePreviousChat && type.vendorType === 'zendesk') {
      setIsShow(true);
      clearInterval(intervalId);
    } else if (intervalCount > 10) {
      clearInterval(intervalId);
    }
  };

  useEffect(() => {
    if (!isLoad) {
      (async function init() {
        setIsLoad(true);
      })();
    }
  }, [isLoad]);

  useEffect(() => {
    if (isLoad) {
      (async function init() {
        const intervalId: any = setInterval(() => setShow(intervalId), 500);
      })();
    }
  }, [isLoad]);

  if (!isShow) {
    return null;
  }

  return (
    <ChatButton onClick={() => window.csHelper?.openPreview()} type="outline">
      지난 상담 내역보기
    </ChatButton>
  );
}
